<template>
    <wrap ref="wrap" :title="title">
        <c-table class="table-w" :amount="true" :head="head" :body="body"></c-table>
    </wrap>
</template>

<script>
  import CTable from './table';
  import mixin from './mixin';
  import Wrap from "./wrap";
  export default {
    name: "QC36",
    mixins: [mixin],
    components: {
      CTable,
      Wrap
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/QC36.vue